// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// Kanji ordered the way a beginner-to-intermediate learner would actually
// encounter them, following the 32-lesson sequence of "Kanji Look and Learn"
// (The Japan Times) rather than the jōyō list's own (largely alphabetical by
// reading) ordering. Used to sort the jōyō kanji list so kanji covered by
// this common teaching order surface first, in that order; anything the book
// doesn't cover keeps the jōyō list's original relative order.
export const kanjiTextbookOrder = [
    // Lesson 1
    "一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "百", "千", "万", "円", "口", "目",
    // Lesson 2
    "日", "月", "火", "水", "木", "金", "土", "曜", "本", "人", "今", "寺", "時", "半", "刀", "分",
    // Lesson 3
    "上", "下", "中", "外", "右", "工", "左", "前", "後", "午", "門", "間", "東", "西", "南", "北",
    // Lesson 4
    "田", "力", "男", "女", "子", "学", "生", "先", "何", "父", "母", "年", "去", "毎", "王", "国",
    // Lesson 5
    "見", "行", "米", "来", "良", "食", "飲", "会", "耳", "聞", "言", "話", "立", "待", "周", "週",
    // Lesson 6
    "大", "小", "高", "安", "新", "古", "元", "気", "多", "少", "広", "早", "長", "明", "好", "友",
    // Lesson 7
    "入", "出", "市", "町", "村", "雨", "電", "車", "馬", "駅", "社", "校", "店", "銀", "病", "院",
    // Lesson 8
    "休", "走", "起", "貝", "買", "売", "読", "書", "帰", "勉", "弓", "虫", "強", "持", "名", "語",
    // Lesson 9
    "春", "夏", "秋", "冬", "朝", "昼", "夕", "方", "晩", "夜", "心", "手", "足", "体", "首", "道",
    // Lesson 10
    "山", "川", "林", "森", "空", "海", "化", "花", "天", "赤", "青", "白", "黒", "色", "魚", "犬",
    // Lesson 11
    "料", "理", "反", "飯", "牛", "豚", "鳥", "肉", "茶", "予", "野", "菜", "切", "作", "未", "味",
    // Lesson 12
    "音", "楽", "歌", "自", "転", "乗", "写", "真", "台", "央", "映", "画", "羊", "洋", "服", "着",
    // Lesson 13
    "家", "矢", "族", "親", "兄", "姉", "弟", "妹", "私", "夫", "妻", "主", "住", "糸", "氏", "紙",
    // Lesson 14
    "教", "室", "羽", "習", "漢", "字", "式", "試", "験", "宿", "題", "文", "英", "質", "問", "説",
    // Lesson 15
    "遠", "近", "者", "暑", "寒", "重", "軽", "低", "弱", "悪", "暗", "太", "豆", "短", "光", "風",
    // Lesson 16
    "運", "動", "止", "歩", "使", "送", "洗", "急", "開", "閉", "押", "引", "思", "知", "考", "死",
    // Lesson 17
    "医", "始", "終", "石", "研", "究", "留", "有", "産", "業", "薬", "働", "員", "士", "仕", "事",
    // Lesson 18
    "図", "官", "館", "昔", "借", "代", "貸", "地", "世", "界", "度", "回", "用", "民", "注", "意",
    // Lesson 19
    "頭", "顔", "声", "特", "別", "竹", "合", "答", "正", "同", "計", "京", "集", "不", "便", "以",
    // Lesson 20
    "場", "戸", "所", "屋", "堂", "都", "県", "区", "池", "発", "建", "物", "品", "旅", "通", "進",
    // Lesson 21
    "丸", "熱", "冷", "甘", "汚", "果", "卵", "皿", "酒", "塩", "付", "片", "焼", "消", "固", "個",
    // Lesson 22
    "笑", "泣", "怒", "幸", "悲", "苦", "痛", "恥", "配", "困", "辛", "眠", "残", "念", "感", "情",
    // Lesson 23
    "覚", "忘", "決", "定", "比", "受", "授", "徒", "練", "復", "表", "卒", "違", "役", "皆", "彼",
    // Lesson 24
    "全", "部", "必", "要", "荷", "由", "届", "利", "払", "濯", "寝", "踊", "活", "末", "宅", "祭",
    // Lesson 25
    "平", "和", "戦", "争", "政", "治", "経", "済", "法", "律", "際", "関", "係", "義", "議", "党",
    // Lesson 26
    "遊", "泳", "疲", "暖", "涼", "静", "公", "園", "込", "連", "窓", "側", "葉", "景", "記", "形",
    // Lesson 27
    "吉", "結", "婚", "共", "供", "両", "若", "老", "息", "娘", "奥", "将", "祖", "育", "性", "招",
    // Lesson 28
    "取", "最", "初", "番", "歳", "枚", "冊", "億", "点", "階", "段", "号", "倍", "次", "々", "他",
    // Lesson 29
    "勝", "負", "賛", "成", "絶", "対", "続", "辞", "投", "選", "約", "束", "守", "過", "夢", "的",
    // Lesson 30
    "飛", "機", "失", "鉄", "速", "遅", "駐", "泊", "船", "座", "席", "島", "陸", "港", "橋", "交",
    // Lesson 31
    "申", "神", "様", "信", "調", "査", "相", "談", "案", "内", "君", "達", "星", "雪", "降", "直",
    // Lesson 32
    "危", "険", "拾", "捨", "戻", "吸", "放", "変", "歯", "髪", "絵", "横", "当", "伝", "細", "無",
];
